"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function nim(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.9594 11.8523L18.9596 11.8526C18.9865 11.8984 19 11.9492 19 12C19 12.0508 18.9865 12.1016 18.9596 12.1474L18.9594 12.1477L15.6246 17.8385C15.6245 17.8388 15.6243 17.8391 15.6241 17.8393C15.5967 17.8856 15.5563 17.9259 15.5055 17.9548C15.4545 17.9837 15.3955 17.9997 15.3346 18H8.66542C8.60448 17.9997 8.54553 17.9837 8.49454 17.9548C8.44374 17.9259 8.40337 17.8856 8.37589 17.8394C8.37572 17.8391 8.37555 17.8388 8.37538 17.8385L5.04061 12.1477L5.04042 12.1474C5.01352 12.1016 5 12.0508 5 12C5 11.9492 5.01352 11.8984 5.04042 11.8526L5.04061 11.8523L8.37538 6.16147C8.37555 6.1612 8.37571 6.16092 8.37588 6.16064C8.40336 6.1144 8.44374 6.07411 8.49454 6.04523C8.54552 6.01626 8.60445 6.0003 8.66536 6H15.3346C15.3956 6.0003 15.4545 6.01626 15.5055 6.04523C15.5563 6.0741 15.5966 6.11438 15.6241 6.16059C15.6243 6.16089 15.6244 6.16118 15.6246 6.16147L18.9594 11.8523Z", stroke: "#F8B425", strokeWidth: 2 }));
}
exports["default"] = nim;
//# sourceMappingURL=nim.js.map